import { SVGProps } from 'react'

const SvgHeroAdjustmentsHorizontal = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg viewBox='0 0 24 24' className='svg-icon' {...props}>
            <path
                d='M9.92163 11.0303H21.8044M9.92163 11.0303C9.92163 11.5151 9.72903 11.9801 9.38619 12.323C9.04335 12.6658 8.57835 12.8584 8.09351 12.8584C7.60866 12.8584 7.14367 12.6658 6.80083 12.323C6.45799 11.9801 6.26538 11.5151 6.26538 11.0303M9.92163 11.0303C9.92163 10.5454 9.72903 10.0804 9.38619 9.73759C9.04335 9.39475 8.57835 9.20215 8.09351 9.20215C7.60866 9.20215 7.14367 9.39475 6.80083 9.73759C6.45799 10.0804 6.26538 10.5454 6.26538 11.0303M6.26538 11.0303H1.69507M17.2341 3.71777H21.8044M17.2341 3.71777C17.2341 4.20262 17.0415 4.66761 16.6987 5.01045C16.3558 5.35329 15.8909 5.5459 15.406 5.5459C14.9212 5.5459 14.4562 5.35329 14.1133 5.01045C13.7705 4.66761 13.5779 4.20262 13.5779 3.71777M17.2341 3.71777C17.2341 3.23292 17.0415 2.76793 16.6987 2.42509C16.3558 2.08225 15.8909 1.88965 15.406 1.88965C14.9212 1.88965 14.4562 2.08225 14.1133 2.42509C13.7705 2.76793 13.5779 3.23292 13.5779 3.71777M13.5779 3.71777H1.69507'
                stroke='#E4E4E7'
                stroke-width='1.88'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    )
}

export default SvgHeroAdjustmentsHorizontal
